import { useEffect } from 'react';
import { useAccordionItem } from './useAccordion';
import { AnimatePresence } from 'motion/react';
import * as motion from 'motion/react-m';
import { P } from '@osmosis/react-ui/components/Text';

/**
 * AccordionPanel.
 */
export const AccordionPanel = ({
  children,
  index,
  onOpen,
  onOpenDependencies = [],
}: {
  children: string;
  index?: number;
  onOpen?: () => void;
  onOpenDependencies?: unknown[];
}) => {
  const isOpen = useAccordionItem(index as any); // FIXME: any

  useEffect(() => {
    isOpen && onOpen?.();
  }, [isOpen, ...onOpenDependencies]);
  return (
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.section
          key="content"
          initial="collapsed"
          animate="open"
          exit="collapsed"
          variants={{
            open: { opacity: 1, height: 'auto' },
            collapsed: { opacity: 0, height: 0 },
          }}
        >
          <motion.div
            variants={{ collapsed: { scale: 0.8 }, open: { scale: 1 } }}
            transition={{ duration: 0.8 }}
            style={{ padding: '20px' }}
          >
            <P dangerouslySetInnerHTML={{ __html: children }} />
          </motion.div>
        </motion.section>
      )}
    </AnimatePresence>
  );
};
